import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Button, Box, Stack } from "@mantine/core";
import toast from "react-hot-toast";

import { Wrapped } from "@legacy/Layouts";

import { ToggleButton } from "@legacy/shared/Buttons";
import { EmptyList } from "@legacy/shared/List";

import AddForm from "./AddForm";
import VersionItem from "./VersionItem";

import { surveyVersions as dummyVersions } from "@dummy/survey";

import "./index.scss";

function List({ surveyId, surveyVariety }) {
  const [addOpen, setAddOpen] = useState(false);
  const [versions, setVersions] = useState([]);

  const fetchData = useCallback(() => {
    axios
      .get(`/surveys/${surveyId}/versions/`)
      .then(({ data }) => {
        setAddOpen(false);
        setVersions(data.versions);
      })
      .catch(() => {
        setVersions(dummyVersions);
      });
  }, [surveyId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onActiveClick = useCallback(
    (versionId) => {
      axios
        .post(`/versions/${versionId}/activate/`)
        .then(() => fetchData())
        .catch((err) => toast.error(err));
    },
    [fetchData]
  );

  const toggleAddOpen = useCallback(() => {
    setAddOpen((open) => !open);
  }, []);

  return (
    <div>
      {surveyVariety !== 2 && (
        <Button onClick={toggleAddOpen}>
          {addOpen ? "Close" : "Add Version"}
        </Button>
      )}
      {addOpen ? (
        <Box mt="md">
          <AddForm onClose={toggleAddOpen} onSubmit={fetchData} id={surveyId} />
        </Box>
      ) : (
        <Stack gap="sm" mt="md">
          {versions.map((v) => (
            <VersionItem
              key={v.id}
              id={v.id}
              active={v.active}
              name={v.name}
              questionCount={v.question_count}
              createdAt={new Date(v.created_at).toLocaleString()}
              number={v.number}
              onActiveClick={() => onActiveClick(v.id)}
              assignerDisabled={[0, 3, 5].includes(surveyVariety)}
              surveyVariety={surveyVariety}
              onUpdate={fetchData}
            />
          ))}
        </Stack>
      )}
    </div>
  );

  return (
    <Wrapped
      title="Versions"
      button={
        surveyVariety !== 2 ? (
          <ToggleButton onClick={toggleAddOpen} open={addOpen} />
        ) : null
      }
    >
      <div>
        {addOpen && (
          <div className="segment">
            <AddForm
              onClose={toggleAddOpen}
              onSubmit={fetchData}
              id={surveyId}
            />
          </div>
        )}
        {!addOpen && (
          <div>
            {versions.map((v) => (
              <VersionItem
                key={v.id}
                id={v.id}
                active={v.active}
                name={v.name}
                questionCount={v.question_count}
                createdAt={new Date(v.created_at).toLocaleString()}
                number={v.number}
                onActiveClick={() => onActiveClick(v.id)}
                assignerDisabled={[0, 3, 5].includes(surveyVariety)}
                surveyVariety={surveyVariety}
                onUpdate={fetchData}
              />
            ))}
            {versions.length === 0 && (
              <EmptyList
                header="Nothing here"
                text="No survey versions. Create one."
              />
            )}
          </div>
        )}
      </div>
    </Wrapped>
  );
}

// List.propTypes = {
//   surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
//     .isRequired,
//   surveyVariety: PropTypes.number.isRequired,
// };

export default List;
